import React from "react";
import { Avatar, Box, Typography } from "@mui/material";

const getInitials = (name) => {
  if (!name) return "??";
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();
};

function PersonAvatar({ name, label }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mt: 1 }}>
      <Avatar
        sx={{
          width: 40,
          height: 40,
          fontSize: "1rem",
          bgcolor: "primary.main",
          color: "#fff",
        }}
      >
        {getInitials(name)}
      </Avatar>
      <Box>
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            lineHeight: 1.1,
            fontSize: "1.3rem",
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            fontSize: "1.3rem",
            lineHeight: 1.2,
            color: "text.primary",
          }}
        >
          {name}
        </Typography>
      </Box>
    </Box>
  );
}

export default PersonAvatar;
